import React from 'react';
import Hero from '../components/Hero';
import OverlapCta from '../components/OverlapCta';
import Community from '../components/Community';
import ClubInfo from '../components/ClubInfo';
import Services from '../components/Services';
import ContactForm from '../components/ContactForm';
import GoogleMap from '../components/GoogleMap';

const HomePage = () => {
  return (
    <>
      <Hero />
      <OverlapCta />
      <Community />
      <ClubInfo />
      <Services />
      <ContactForm />
      <GoogleMap />
    </>
  );
};

export default HomePage;
